import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'modules/react/components/stateless/Icon';
import * as pageTypes from 'shared/pageTypes';
import style from './PageTitle.scss';

const { FACILITY_LINK, FACILITY_LISTING, FACILITY_PAGE, HOME_PAGE } = pageTypes;

const propTypes = {
  metadata: PropTypes.shape({
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  facility: PropTypes.object,
};

const defaultProps = {
  facility: {},
};

const fullTitle = ({ facility, pageTitle, pageType }) => (
  <div>
    <div>
      <span>
        {pageTitle}
      </span>
      {facility && !facility.enabled &&
        <span className={style.disabledFacility}>
          disabled
        </span>
      }
    </div>
    {facility && facility.address && pageType !== HOME_PAGE &&
      <div className={style.facilityAddress}>
        {facility.address.fullAddress}
      </div>
    }
  </div>
);

const leanTitle = ({ pageTitle, pageType }) => (
  <div>
    {pageTitle}
    <span className={style.facilityIcon}>
      <Icon
        id={pageType === FACILITY_LINK ? 'linkout' : 'listing'}
        label="facility icon"
      />
    </span>
  </div>
);

// TODO: Remove this component altogether or make it less cruddy. We have a newer <PageTitle />
// component in admin/ that we should probably leverage. We can't use it for this right now because
// it multi-lines the address, causing inconsistent row heights in the page list. We also need to
// reconsider what "Disabled" means on a facility page in a world with multiple websites per
// company since it's more complicated than the facility being voyager-enabled in storEDGE now.
const PageTitle = ({ metadata: { internalPageName, title, type }, facility }) => {
  const pageTypeKey = Object.keys(pageTypes).find(key => pageTypes[key] === type);
  const pageType = pageTypes[pageTypeKey];
  const pageTitle = internalPageName || title;

  // for single-facility sites, the home page is also a facility page
  if ([FACILITY_PAGE, HOME_PAGE].includes(pageType)) {
    return (
      <div>
        {fullTitle({ facility, pageTitle, pageType })}
      </div>
    );
  }

  if ([FACILITY_LINK, FACILITY_LISTING].includes(pageType)) {
    return (
      <div>
        {leanTitle({ pageTitle, pageType })}
      </div>
    );
  }

  return <div>{pageTitle}</div>;
};

PageTitle.propTypes = propTypes;
PageTitle.defaultProps = defaultProps;

export default PageTitle;
